import { lazy } from 'react'

import type { RouteObject } from 'react-router'

import { CadastrarClienteAtendimentoPageSuspense } from '@/features/atendimento/brasil/pages/cadastrar-cliente-atendimento/suspense'
import { IniciarAtendimentoPageSuspense } from '@/features/atendimento/brasil/pages/iniciar-atendimento/suspense'
import { UltimosAtendimentosPageSuspense } from '@/features/atendimento/brasil/pages/ultimos-atendimentos/suspense'

const UltimosAtendimentosPage = lazy(() =>
  import('@/features/atendimento/brasil/pages/ultimos-atendimentos').then((module) => ({
    default: module.UltimosAtendimentosPage,
  })),
)

const IniciarAtendimentoPage = lazy(() =>
  import('@/features/atendimento/brasil/pages/iniciar-atendimento').then((module) => ({
    default: module.IniciarAtendimentoPage,
  })),
)

const CadastrarClienteAtendimentoPage = lazy(() =>
  import('@/features/atendimento/brasil/pages/cadastrar-cliente-atendimento').then((module) => ({
    default: module.CadastrarClienteAtendimentoPage,
  })),
)

export const brasilAtendimentoRoutes: RouteObject[] = [
  {
    index: true,
    element: (
      <UltimosAtendimentosPageSuspense>
        <UltimosAtendimentosPage />
      </UltimosAtendimentosPageSuspense>
    ),
  },
  {
    path: 'atendimento',
    children: [
      {
        path: 'iniciar',
        element: (
          <IniciarAtendimentoPageSuspense>
            <IniciarAtendimentoPage />
          </IniciarAtendimentoPageSuspense>
        ),
      },
      {
        path: 'cadastrar',
        element: (
          <CadastrarClienteAtendimentoPageSuspense>
            <CadastrarClienteAtendimentoPage />
          </CadastrarClienteAtendimentoPageSuspense>
        ),
      },
    ],
  },
]
